import React, { Component } from 'react';
import { connect, FormikContext } from 'formik';
import Input from '../../../../components/input/text/input-formik';
import { IExamActivityAddProps, IOuterProps, IFormikProps } from '../../../../models/components/add-activity-exam-content';
import { DatetimeFormik } from '../../../../components/input/date-time/date-time-formik';
import { Quil } from '../../../../components/input/quil/main';
import { SelectAsync, SelectNoneAsync } from '../../../../components/input/select/main';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import { Log } from 'ng2-logger';
import Translator from '../../../../core/i18n';
import { Confirm } from '../../../../components/notification/main';
import Switch from 'react-switch';
import { Common } from '../../../../core/common';
import { ExamScoringType } from '../../../../models/enums/ExamScoringType';
import { ExamQuestionWeightingType } from '../../../../models/enums/ExamQuestionWeightingType';
import { QuestionWeight } from './questionWeight';
import { ActivityTiming } from '../../../../components/add-activity/timing';
import Tooltip from '../../../../components/tooltip/main';

const T = Translator.create();
const _logger = Log.create('Exam Add Page Content');
let _common: Common;
export class ExamActivityContent extends Component<IFormikProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public examEntryTypeControl = (type: number) => {
        this.props.formik.setFieldValue('examEntryDateType', type);
    };

    public examRepeatCountInfinityControl = () => {
        this.props.formik.setFieldValue('examRepeatCountInfinity', !this.props.formik.values.examRepeatCountInfinity);
        this.props.formik.setFieldValue('repeatCount', this.props.formik.values.examRepeatCountInfinity ? 1 : 0);

    };

    renderCompletionTypes = () => {
        return (
            this.props && this.props.isUpdate != "" ?
                <div className="row">
                    {this.props.formik.values.completionType === ActivityCompletionType.Complete ?

                        <div className="col-md-4">
                            <div className="radio-tabs tick-radio position-relative">
                                <input
                                    type="radio"
                                    name={'completionType'}
                                    value={ActivityCompletionType.Complete}
                                    defaultChecked={true}
                                    onChange={this.props.formik.setFieldValue.bind(this, 'completionType', ActivityCompletionType.Complete)}
                                    id="activity-one"
                                    className="form-radio"
                                    checked={this.props.formik.values.completionType === ActivityCompletionType.Complete}
                                />
                                <label htmlFor="activity-one">{T.t('r_gen_enrollment_completed')}</label>
                            </div>
                        </div>
                        : this.props.formik.values.completionType === ActivityCompletionType.Grade &&

                        <div className="col-md-4">
                            <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                                <input
                                    type="radio"
                                    name={'completionType'}
                                    value={ActivityCompletionType.Grade}
                                    onChange={this.props.formik.setFieldValue.bind(this, 'completionType', ActivityCompletionType.Grade)}
                                    id="activity-two"
                                    className="form-radio"
                                    checked={this.props.formik.values.completionType === ActivityCompletionType.Grade}
                                />
                                <label htmlFor="activity-two">
                                    {T.t('r_add_exam_score')}
                                    <span className="ml-1" style={{ color: '#dc5050' }}>
                                        *
                                    </span>
                                </label>
                            </div>
                            <div
                                className={
                                    'animated ' +
                                    (this.props.formik.values.completionType === ActivityCompletionType.Grade ? 'fadeInDown' : 'fadeOutDown')
                                }
                                style={{
                                    animationDuration: '0.3s',
                                    display: this.props.formik.values.completionType === ActivityCompletionType.Grade ? 'block' : 'none',
                                    marginTop: '1.5rem'
                                }}
                            >
                                <Input type={'text'} name={'completionCriteria'} label={T.t('r_grade')} formik={this.props.formik} />
                            </div>
                        </div>
                    }
                </div>
                :
                <div className="row">
                    <div className="col-md-4">
                        <div className="radio-tabs tick-radio position-relative">
                            <input
                                type="radio"
                                name={'completionType'}
                                value={ActivityCompletionType.Complete}
                                defaultChecked={true}
                                onChange={this.props.formik.setFieldValue.bind(this, 'completionType', ActivityCompletionType.Complete)}
                                id="activity-one"
                                className="form-radio"
                                checked={this.props.formik.values.completionType === ActivityCompletionType.Complete}
                            />
                            <label htmlFor="activity-one">{T.t('r_gen_enrollment_completed')}</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                            <input
                                type="radio"
                                name={'completionType'}
                                value={ActivityCompletionType.Grade}
                                onChange={this.props.formik.setFieldValue.bind(this, 'completionType', ActivityCompletionType.Grade)}
                                id="activity-two"
                                className="form-radio"
                                checked={this.props.formik.values.completionType === ActivityCompletionType.Grade}
                            />
                            <label htmlFor="activity-two">
                                {T.t('r_add_exam_score')}
                                <span className="ml-1" style={{ color: '#dc5050' }}>
                                    *
                                </span>
                            </label>
                        </div>
                        <div
                            className={
                                'animated ' +
                                (this.props.formik.values.completionType === ActivityCompletionType.Grade ? 'fadeInDown' : 'fadeOutDown')
                            }
                            style={{
                                animationDuration: '0.3s',
                                display: this.props.formik.values.completionType === ActivityCompletionType.Grade ? 'block' : 'none',
                            }}
                        >
                            <Input type={'number'} name={'completionCriteria'} label={T.t('r_grade')} formik={this.props.formik} />
                        </div>
                    </div>
                </div>
        )
    }

    renderDatePickers = () => {
        return (
            !this.props.isUpdate && (
                <div className="row mt-4">
                    <div className="col-md-6" id="exam_start_date">
                        <h5>
                            {T.t('r_add_exam_session_begin_date')}
                            <span className="ml-1" style={{ color: '#dc5050' }}>
                                *
                            </span>
                        </h5>
                        <div style={{ width: '50%', float: 'left' }}>
                            <DatetimeFormik
                                name={'examSessionBeginDate'}
                                dateFormat={this.props.dateFormat}
                                formik={this.props.formik}
                                placeHolder={T.t('r_datetime_picker_date')}
                                datePickerId={'examSessionBeginDate'}
                                mode="single"
                                static={true}
                                activityType={this.props.activityType}
                            />
                        </div>
                        <div style={{ width: '40%', float: 'right' }}>
                            <DatetimeFormik
                                name={'examSessionBeginDateTime'}
                                formik={this.props.formik}
                                datePickerId={'examSessionBeginDateTime'}
                                placeHolder={T.t('r_time')}
                                mode="time"
                                time24Hr={true}
                                static={true}
                                activityType={this.props.activityType}
                            />
                        </div>
                    </div>
                    <div className="col-md-6" id="exam_end_date">
                        <h5>
                            {T.t('r_add_exam_session_end_date')}
                            <span className="ml-1" style={{ color: '#dc5050' }}>
                                *
                            </span>
                        </h5>
                        <div style={{ width: '50%', float: 'left' }}>
                            <DatetimeFormik
                                name={'examSessionEndDate'}
                                dateFormat={this.props.dateFormat}
                                formik={this.props.formik}
                                placeHolder={T.t('r_datetime_picker_date')}
                                datePickerId={'examSessionEndDate'}
                                mode="single"
                                static={true}
                                activityType={this.props.activityType}
                            />
                        </div>
                        <div id="exam-session-end-date" style={{ width: '40%', float: 'right' }}>
                            <DatetimeFormik
                                name={'examSessionEndDateTime'}
                                formik={this.props.formik}
                                datePickerId={'examSessionEndDateTime'}
                                placeHolder={T.t('r_time')}
                                mode="time"
                                time24Hr={true}
                                flatPickrClass={'date-picker-width'}
                                static={true}
                                activityType={this.props.activityType}
                            />
                        </div>
                    </div>
                </div>
            )
        )
    }

    renderAutoEnroll = () => {
        return (
            !this.props.isUpdate && (
                <div className="row mt-2">
                    <div className="col-md-12">
                        <div style={{ float: 'left', marginTop: 2 }}>
                            <Switch
                                id={'check-autoEnroll'}
                                name={'autoEnroll'}
                                // tslint:disable-next-line:jsx-no-lambda
                                onChange={(e: any) => this.props.formik.setFieldValue('autoEnroll', e)}
                                checked={this.props.formik.values.autoEnroll}
                                defaultChecked={true}
                                onColor="#358730"
                                onHandleColor="#358730"
                                handleDiameter={18}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={38}
                                className="react-switch"
                            />
                        </div>
                        <label htmlFor="check-autoEnroll" style={{ marginLeft: 15 }}>
                            {T.t('r_add_exam_auto_enroll')}
                        </label>
                    </div>
                </div>
            )
        )
    }

    examSecurityProfile = () => {
        return (
            <><div className="row mt-2">
                <div className="col-md-12">
                    <div style={{ float: 'left', marginTop: 2 }}>
                        <Switch
                            id={'check-isUseExamExternalSecurity'}
                            name={'isUseExamExternalSecurity'}
                            onChange={(e: any) => this.props.formik.setFieldValue('isUseExamExternalSecurity', e)}
                            checked={this.props.formik.values.isUseExamExternalSecurity}
                            onColor="#358730"
                            onHandleColor="#358730"
                            handleDiameter={18}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={38}
                            className="react-switch" />
                    </div>
                    <div style={{ float: 'left', width: '90%' }}>
                        <label htmlFor="check-isUseExamExternalSecurity" style={{ marginLeft: 15 }}>
                            {T.t('r_add_exam_use_external_security')}
                        </label>
                    </div>
                </div>
            </div><div className="row mt-2" style={{ display: this.props.formik.values.isUseExamExternalSecurity ? 'block' : 'none' }}>
                    <div className="col-md-12">
                        <div>
                            <h5>{T.t('r_add_exam_select_security_profile')}</h5>
                            <SelectAsync
                                isMulti={false}
                                requestType={'post'}
                                parameter={{ 'ExamSecurityType': 0 }}
                                placeHolder={T.t('r_add_exam_select_security_profile')}
                                url={'api/exam/getExamSecurityProfiles'}
                                closeMenuOnScroll={false}
                                closeMenuOnSelect={true}
                                setSelectValue={this.props.isUpdate ? this.props.formik.values.examExternalSecurityProfile : ''}
                                name={'examExternalSecurityProfile'}
                                value={this.props.formik.values.examExternalSecurityProfile}
                                onChange={this.props.formik.handleChange}
                                setFieldValue={this.props.formik.setFieldValue}
                                errors={this.props.formik.errors.examExternalSecurityProfile}
                                touched={this.props.formik.touched.examExternalSecurityProfile}
                                isTouched={this.props.formik.setFieldTouched}
                                hasLocalization={true}
                                setFieldOnlyValue={true} />
                        </div>
                    </div>
                </div></>
        )
    }

    returnIsPublished = () => {
        let isExamPublished: boolean = false;
        if (this.props.isUpdate && this.props.publishDatas) {
            if (this.props.publishDatas.isPassive === 0 && this.props.publishDatas.activeStatus === 1) {
                isExamPublished = true
            }
        }
        return isExamPublished;
    }

    renderQuils = () => {
        let defaultExamPreMessage;
        let defaultExamPostMessage;
        if (this.props.examMessages) {
            defaultExamPreMessage = this.props.examMessages.defaultExamPreMessage;
            defaultExamPostMessage = this.props.examMessages.defaultExamPostMessage;
        }

        return (
            <>
                <h5 className="input-label mx-0">{T.t('r_Instructor_note_description')}</h5>
                <Quil
                    modules={'basic'}
                    placeholder={T.t('r_write_description_for_activity')}
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={(e: any) => this.props.formik.setFieldValue('description', e)}
                    value={this.props.formik.values.description || ''}
                    theme={'snow'}
                />
                <h5 className="input-label mx-0">{T.t('r_add_exam_pre_message')}</h5>
                <Quil
                    id='examPreMessage'
                    modules={'basic'}
                    placeholder={T.t('r_add_exam_pre_message')}
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={(e: any) => this.props.formik.setFieldValue('examPreMessage', e)}
                    value={defaultExamPreMessage ?? (this.props.formik.values.examPreMessage || '')}
                    theme={'snow'}
                />
                <h5 className="input-label mx-0">{T.t('r_add_exam_post_message')}</h5>
                <Quil
                    modules={'basic'}
                    placeholder={T.t('r_add_exam_post_message')}
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={(e: any) => this.props.formik.setFieldValue('examPostMessage', e)}
                    value={defaultExamPostMessage ?? (this.props.formik.values.examPostMessage || '')}
                    theme={'snow'}
                />
            </>
        )
    }

    public render() {
        const scoringType = [
            { value: ExamScoringType.Average, label: T.t('r_exam_scoring_type_Average') },
            { value: ExamScoringType.FirstAttempt, label: T.t('r_exam_scoring_type_FirstAttempt') },
            { value: ExamScoringType.Highest, label: T.t('r_exam_scoring_type_Highest') },
            { value: ExamScoringType.LastAttempt, label: T.t('r_exam_scoring_type_LastAttempt') },
            { value: ExamScoringType.Lowest, label: T.t('r_exam_scoring_type_Lowest') }
        ];

        let displayType = this.props.formik.values.allowStudentToSeeExamReport ? 'flex' : 'none';

        let isExamPublished = this.returnIsPublished();

        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_contentTab' ? ' show active' : '')}
                style={{ display: this.props.currentTab === '_contentTab' ? 'block' : 'none' }}
                id="exam-setting"
                role="tabpanel"
                aria-labelledby="exam-setting-tab"
            >
                <h5 className="input-label mx-0">{T.t('r_activity_search_placeholder')}<span className="ml-1" style={{ color: '#dc5050' }}>*</span></h5>
                <Input type={'text'} name={'name'} placeHolder={T.t('r_activity_search_placeholder')} formik={this.props.formik} />

                <p className="half-color">{T.t('r_activity_list_shown_text')}</p>

                {this.renderQuils()}

                <div className="row mt-4">
                    <div className="col-md-4">
                        <div>
                            <div className='row'><div className="col-md-12 show-more" style={{ fontSize: "12px", justifyContent: "start" }}>{T.t('r_add_exam_duration')}</div></div>
                            <div className="row" style={{ marginTop: "0px" }}>

                                <div className="col-md-12">

                                    <Input inputClass='input-top' placeholderClassName={'input-top-placeholder'} placeHolder={(!this.props.formik.values.examDurationInMinutes) ? T.t('r_time_minute') : ''} disable={isExamPublished} type={'number'} name={'examDurationInMinutes'} min={1} formik={this.props.formik} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div>
                            <div className='row'><div className="col-md-12 show-more" style={{ fontSize: "12px", justifyContent: "start" }}>{T.t('r_add_exam_repeat_count')}</div></div>
                            <div className="row" style={{ marginTop: "0px" }}>

                                <div className="col-md-12">

                                    <Input inputClass='input-top'
                                        disable={this.props.formik.values.examRepeatCountInfinity}
                                        type={!this.props.formik.values.examRepeatCountInfinity ? 'number' : 'text'}
                                        name={'repeatCount'}
                                        max={100}
                                        min={this.props.formik.values.examRepeatCountInfinity ? 0 : 1}
                                        {...(this.props.formik.values.examRepeatCountInfinity ? { value: '∞' } : {})}
                                        formik={this.props.formik}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div><div className='row'><div className="col-md-12 show-more" style={{ fontSize: "12px", justifyContent: "start" }}>{T.t('r_add_exam_question_count')}</div></div>
                            <div className="row" style={{ marginTop: "0px" }}>

                                <div className="col-md-12">
                                    <Input inputClass='input-top' disable={isExamPublished} type={'number'} name={'examQuestionCount'} max={1000} min={1} formik={this.props.formik} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <div className="tick-radio">
                            <input
                                type="checkbox"
                                name={'examRepeatCountInfinity'}
                                onChange={this.examRepeatCountInfinityControl}
                                id="exam-repeat-count-infinity"
                                className="form-radio"
                                checked={this.props.formik.values.examRepeatCountInfinity}
                                style={{ borderRadius: 100, marginTop: 2 }}
                            />
                            <label htmlFor="exam-repeat-count-infinity">{T.t('r_add_exam_repeat_count_infinity_text')}</label>
                        </div>
                    </div>
                </div>

                {this.renderDatePickers()}

                <h5 className="mt-1 mb-3">
                    {T.t('r_add_exam_entry_date_type')}
                    <span className="ml-1" style={{ color: '#dc5050' }}>
                        *
                    </span>
                </h5>
                <div className="row">
                    <div className="col-md-6">
                        <div className="tick-radio position-relative align-items-start">
                            <input
                                type="checkbox"
                                name={'examEntryDateType'}
                                onChange={this.examEntryTypeControl.bind(this, 0)}
                                value={0}
                                id="exam-entry-date-type-zero"
                                className="form-radio"
                                checked={this.props.formik.values.examEntryDateType === 0}
                                style={{ borderRadius: 100, marginTop: 2 }}
                            />
                            <label htmlFor="exam-entry-date-type-zero ">{T.t('r_add_exam_login_within_given_time')}</label>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="tick-radio position-relative align-items-start" >
                            <input
                                type="checkbox"
                                name={'examEntryDateType'}
                                onChange={this.examEntryTypeControl.bind(this, 1)}
                                value={1}
                                id="exam-entry-date-type-one"
                                className="form-radio"
                                checked={this.props.formik.values.examEntryDateType === 1}
                                style={{ borderRadius: 100, marginTop: 2 }}
                            />
                            <label htmlFor="exam-entry-date-type-one">{T.t('r_add_exam_given_time_expires_exam_completed')}</label>
                        </div>
                    </div>
                </div>

                <div className="exam-date">
                    <h5 className="mt-4">{T.t('r_add_exam_show_answer_specified_date')}</h5>
                    <p className="mt-0">{T.t('r_add_exam_show_answer_specified_date_info')}</p>
                    <div className="row" id="exam_note_date">
                        <div className="col-md-6">
                            <div style={{ width: '50%', float: 'left' }}>
                                <DatetimeFormik
                                    name={'examShowAnswerSpecifiedDate'}
                                    dateFormat={this.props.dateFormat}
                                    formik={this.props.formik}
                                    placeHolder={T.t('r_datetime_picker_date')}
                                    datePickerId={'examShowAnswerSpecifiedDate'}
                                    mode="single"
                                    static={true}
                                    activityType={this.props.activityType}
                                />
                            </div>
                            <div style={{ width: '40%', float: 'right' }}>
                                <DatetimeFormik
                                    name={'examShowAnswerSpecifiedDateTime'}
                                    formik={this.props.formik}
                                    datePickerId={'examShowAnswerSpecifiedDateTime'}
                                    placeHolder={T.t('r_time')}
                                    mode="time"
                                    time24Hr={true}
                                    static={true}
                                    activityType={this.props.activityType}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <ActivityTiming
                    coursePageActivityId={this.props.coursePageActivityId}
                    coursePageClassId={this.props.coursePageClassId}
                    dateFormat={this.props.dateFormat}
                    formik={this.props.formik}
                    isUpdate={this.props.isUpdate}
                    isWeekly={this.props.isWeekly}
                    termType={this.props.termType ?? T.t('r_time_week')}

                />

                <div className="row mt-4">
                    <div className={'col-md-' + (this.props.isUpdate ? '12' : '6')}>
                        <div>
                            <h5>{T.t('r_add_exam_category')}</h5>
                            <SelectAsync
                                isMulti={false}
                                requestType={'post'}
                                parameter={{}}
                                placeHolder={T.t('r_add_exam_select_category')}
                                url={'api/exam/category/get'}
                                closeMenuOnScroll={false}
                                closeMenuOnSelect={true}
                                setSelectValue={this.props.isUpdate ? this.props.formik.values.examCategoryId : 'Test'}
                                name={'examCategoryId'}
                                value={this.props.formik.values.examCategoryId}
                                onChange={this.props.formik.handleChange}
                                setFieldValue={this.props.formik.setFieldValue}
                                errors={this.props.formik.errors.examCategoryId}
                                touched={this.props.formik.touched.examCategoryId}
                                isTouched={this.props.formik.setFieldTouched}
                                hasLocalization={true}
                                setFieldOnlyValue={true}
                            />
                        </div>
                    </div>
                    {!this.props.isUpdate ? (
                        <div className="col-md-6">
                            <div>
                                <h5>{T.t('r_add_exam_scoring_type')}</h5>
                                <SelectNoneAsync
                                    isMulti={false}
                                    name={'examScoringType'}
                                    touched={this.props.formik.touched.examScoringType}
                                    errors={this.props.formik.errors.examScoringType}
                                    setFieldValue={this.props.formik.setFieldValue}
                                    setOptions={scoringType}
                                    // tslint:disable-next-line:jsx-no-lambda
                                    onChange={(e: any) => this.props.formik.setFieldValue('examScoringType', e ? e.value : null)}
                                    isTouched={this.props.formik.setFieldTouched}
                                    placeHolder={T.t('r_add_exam_select_scoring_type')}
                                    setSelectValue={this.props.isUpdate ? [this.props.formik.values.examScoringType] : [2]}
                                    isClearable={false}
                                />
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>

                <QuestionWeight
                    coursePageActivityId={this.props.coursePageActivityId}
                    formik={this.props.formik}
                    isUpdate={this.props.isUpdate}
                    isExamPublished={isExamPublished}
                />

                <div className="row mt-4">
                    <div className="col-md-12">
                        <div style={{ float: 'left', marginTop: 2 }}>
                            <Switch
                                id={'check-isRandomQuestion'}
                                name={'isRandomQuestion'}
                                // tslint:disable-next-line:jsx-no-lambda
                                onChange={(e: any) => this.props.formik.setFieldValue('isRandomQuestion', e)}
                                checked={this.props.formik.values.isRandomQuestion}
                                defaultChecked={true}
                                onColor="#358730"
                                onHandleColor="#358730"
                                handleDiameter={18}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={38}
                                className="react-switch"
                                disabled={isExamPublished}
                            />
                        </div>
                        <label htmlFor="check-isRandomQuestion" style={{ marginLeft: 15 }}>
                            {T.t('r_add_exam_random_question')}
                        </label>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-md-12">
                        <div style={{ float: 'left', marginTop: 2 }}>
                            <Switch
                                id={'check-isRandomChoice'}
                                name={'isRandomChoice'}
                                // tslint:disable-next-line:jsx-no-lambda
                                onChange={(e: any) => this.props.formik.setFieldValue('isRandomChoice', e)}
                                checked={this.props.formik.values.isRandomChoice}
                                defaultChecked={true}
                                onColor="#358730"
                                onHandleColor="#358730"
                                handleDiameter={18}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={38}
                                className="react-switch"
                                disabled={isExamPublished}
                            />
                        </div>
                        <label htmlFor="check-isRandomChoice" style={{ marginLeft: 15 }}>
                            {T.t('r_add_exam_random_choice')}
                        </label>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-md-12">
                        <div style={{ float: 'left', marginTop: 2 }}>
                            <Switch
                                id={'check-showQuestionScoreInExam'}
                                name={'showQuestionScoreInExam'}
                                // tslint:disable-next-line:jsx-no-lambda
                                onChange={(e: any) => this.props.formik.setFieldValue('showQuestionScoreInExam', e)}
                                checked={this.props.formik.values.showQuestionScoreInExam}
                                onColor="#358730"
                                onHandleColor="#358730"
                                handleDiameter={18}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={38}
                                className="react-switch"
                            />
                        </div>
                        <label htmlFor="check-showQuestionScoreInExam" style={{ marginLeft: 15 }}>
                            {T.t('r_add_exam_show_score_inexam')}
                        </label>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-md-12">
                        <div style={{ float: 'left', marginTop: 2 }}>
                            <Switch
                                id={'check-allowStudentToSeeExamReport'}
                                name={'allowStudentToSeeExamReport'}
                                // tslint:disable-next-line:jsx-no-lambda
                                onChange={(e: any) => this.props.formik.setFieldValue('allowStudentToSeeExamReport', e)}
                                checked={this.props.formik.values.allowStudentToSeeExamReport}
                                onColor="#358730"
                                onHandleColor="#358730"
                                handleDiameter={18}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={38}
                                className="react-switch"
                            />
                        </div>
                        <label htmlFor="check-allowStudentToSeeExamReport" style={{ marginLeft: 15 }}>
                            {T.t('r_add_exam_show_report')}
                        </label>
                    </div>
                </div>

                <div className="row mt-2" style={{ display: displayType }}>
                    <div className="col-md-12">
                        <div style={{ float: 'left', marginTop: 2 }}>
                            <Switch
                                id={'check-showStudentReportAfterFirstAttempt'}
                                name={'showStudentReportAfterFirstAttempt'}
                                // tslint:disable-next-line:jsx-no-lambda
                                onChange={(e: any) => this.props.formik.setFieldValue('showStudentReportAfterFirstAttempt', e)}
                                checked={this.props.formik.values.showStudentReportAfterFirstAttempt!}
                                onColor="#358730"
                                onHandleColor="#358730"
                                handleDiameter={18}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={38}
                                className="react-switch"
                            />
                        </div>
                        <div style={{ float: 'left', width: '90%' }}>
                            <label htmlFor="check-showStudentReportAfterFirstAttempt" style={{ marginLeft: 15 }}>
                                {T.t('r_add_exam_show_student_report_after_first_attempt')}
                            </label>
                        </div>
                    </div>
                </div>

                <div className="row mt-2" style={{ display: displayType }}>
                    <div className="col-md-12">
                        <div style={{ float: 'left', marginTop: 2 }}>
                            <Switch
                                id={'check-showStudentOnlyExamPoints'}
                                name={'showStudentOnlyExamPoints'}
                                // tslint:disable-next-line:jsx-no-lambda
                                onChange={(e: any) => this.props.formik.setFieldValue('showStudentOnlyExamPoints', e)}
                                checked={this.props.formik.values.showStudentOnlyExamPoints!}
                                onColor="#358730"
                                onHandleColor="#358730"
                                handleDiameter={18}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={38}
                                className="react-switch"
                            />
                        </div>
                        <label htmlFor="check-showStudentOnlyExamPoints" style={{ marginLeft: 15 }}>
                            {T.t('r_add_exam_show_student_only_exam_points')}
                        </label>
                    </div>
                </div>

                {this.renderAutoEnroll()}

                {/* <div className="row mt-2">
                    <div className="col-md-12">
                        <div style={{ float: 'left', marginTop: 2 }}>
                            <Switch
                                id={'check-customProperty4'}
                                name={'customProperty4'}
                                // tslint:disable-next-line:jsx-no-lambda
                                onChange={(e: any) => this.props.formik.setFieldValue('customProperty4', e)}
                                checked={this.props.formik.values.customProperty4}
                                onColor="#358730"
                                onHandleColor="#358730"
                                handleDiameter={18}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={38}
                                className="react-switch"
                            />
                        </div>
                        <div style={{ float: 'left', width: '90%' }}>
                            <label htmlFor="check-customProperty4" style={{ marginLeft: 15 }}>
                                {T.t('r_add_exam_custom_property_4')}
                            </label>
                        </div>
                    </div>
                </div>

                <div className="row mt-2" style={{ display: this.props.formik.values.customProperty4 ? 'block' : 'none' }}>
                    <div className="col-md-12">
                        <div>
                            <h5>
                                {T.t('r_add_exam_custom_property_5')}
                                <span className="ml-1" style={{ color: '#dc5050' }}>
                                    *
                                </span>
                            </h5>
                            <Input type={'number'} name={'customProperty5'} min={2} formik={this.props.formik} />
                        </div>
                    </div>
                </div> */}

                {this.examSecurityProfile()}

                <div className='d-flex align-items-center  mt-3'>
                    <h5 className="mt-3 mt-0">
                        {T.t('r_activity_finish_criteria')}
                        <span className="ml-1" style={{ color: '#dc5050' }}>
                            *
                        </span>
                    </h5>
                    <Tooltip data={T.t('r_activity_finish_criteria_info')} position='top' heightValue='2em'>
                        <img src={_common.GetDefaultIcons('info')} style={{ width: '1em', height: '1em', marginInlineStart: "8px" }} alt="" />
                    </Tooltip>
                </div>
                {this.renderCompletionTypes()}
            </div>
        );
    }
}

export default connect<IExamActivityAddProps, IOuterProps>(ExamActivityContent);
